import { Layer } from "../../types/layer";
import LayerControlItem from "./LayerControlItem";

interface MeasureControlProps {
  layer: Layer | null;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
}

const MeasureControl: React.FC<MeasureControlProps> = ({ layer, expanded, onExpandedChange }) => {
  if (!layer) return null;

  const handleToggleVisibility = () => {
    layer.toolbarButton?.props?.onClick?.();
  };

  return (
    <LayerControlItem
      title="Measure"
      icon="straighten"
      visible={layer.active ?? false}
      onToggleVisibility={handleToggleVisibility}
      enabled={true}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
    />
  );
};

export default MeasureControl;
